import { render, staticRenderFns } from "./papersList.vue?vue&type=template&id=43d94497&"
import script from "./papersList.vue?vue&type=script&lang=js&"
export * from "./papersList.vue?vue&type=script&lang=js&"
import style0 from "./papersList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports